/**
 * Guía: Pagos a Asesores.
 *
 * Contenido derivado del capítulo **28** del manual: §0 (el tercer módulo de
 * pagos con la misma forma) y del flujo F30 §4, que trae los cuatro saldos y
 * el bloqueo de la cuenta bancaria.
 */

import type { TourFlow } from '../types';

// Desde el 2026-10-15 cuelga de «Pagos a asesores» (antes era su propia
// entrada del menú, `/finance-advisor-payouts`).
const PAGOS_ASESOR_PATH = '/commercial-advisors/payouts';

export const c28PagosAAsesores: TourFlow = {
  id: 'admin.finance-advisor-payouts',
  chapter: '28',
  title: 'Liquidaciones a asesores',
  summary:
    'El tercer módulo de pagos: los cuatro saldos de un asesor y qué lo deja fuera de una corrida.',
  href: PAGOS_ASESOR_PATH,
  // SUPPORT_LEAD llega a la lista de asesores, no a las liquidaciones.
  roles: ['SUPER_ADMIN', 'FINANCE'],
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'La misma forma que los otros dos módulos de pago',
      body:
        'Comercios, creadores y asesores se liquidan igual: se genera el periodo, se agrupa ' +
        'y se marca transferido. Lo que cambia es de dónde sale el dinero y quién lo cobra.',
      route: PAGOS_ASESOR_PATH,
    },
    {
      id: 'four-balances',
      title: 'Cuatro saldos que no son lo mismo',
      body:
        'Disponible es lo listo para liquidar; en curso, lo ya comprometido; por recuperar, ' +
        'comisión que hay que devolver; total ganado es histórico y no es dinero por cobrar. ' +
        'El disponible **ya lleva restado** lo que hay por recuperar.',
      target: 'admin.advisorPayouts.kpis',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'clawback',
      title: 'Por qué baja un saldo sin haberle pagado',
      body:
        'Porque una venta que ya le comisionó se devolvió. Esa comisión deja de existir y, ' +
        'si ya se le pagó, se descuenta de lo siguiente. Es la explicación de casi todos los ' +
        '«mi saldo bajó solo».',
    },
    {
      id: 'skipped',
      title: 'Qué deja a un asesor fuera de una corrida',
      body:
        'No llegar al mínimo del periodo, o no tener cuenta bancaria principal aprobada. El ' +
        'informe de la corrida lo dice por nombre — pero el asesor no lo ve, así que hay ' +
        'que mirarlo antes de que pregunte.',
    },
  ],
};
